export default {"src":"/_next/static/media/pan_mismatch.0f3292b8.svg","height":243,"width":301,"blurWidth":0,"blurHeight":0};